import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
@Component({
  selector: 'app-site-edit',
  templateUrl: './site-edit.component.html',
  styleUrls: ['./site-edit.component.scss']
})
export class SiteEditComponent implements OnInit {
  EditOption: IEditOptions;
 
  constructor(public _manikEntityService: ManikEntityService,
     private cdRef: ChangeDetectorRef) {
      
      }
  ngOnInit(): void {
    
    this._manikEntityService.Data.subscribe(editopt => {
      if (editopt) {
        this.EditOption = editopt;
        // this.cdRef.detectChanges();  // Dont use this untill dont get any other solution
        
          setInterval(() => {
            this.cdRef.detectChanges();
          }, 50);
      }
    });
  }
 
  ShowEditComponent(Name: string) {
    let loadComponent: boolean = false;
    if (this.EditOption.Type === Name){
      loadComponent = true;
      return loadComponent;
    }
  
  }
}

export interface IEditOptions {
  Type: string;
  BusinessHandle: string;
  PortalContext: string;
  PortalDS: string;
  BusinessID: string;
}
